import React from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";
import includes from "lodash/includes";
import Button from "components/common/Button";
import TextBox from "components/common/TextBox";
import useFormHandlers from "utils/useFormHandlers";

const schema = Yup.object().shape({
    gameSettings: Yup.string().test("json", "Invalid JSON format", (value) => {
        try {
            JSON.parse(value);
            return true;
        } catch (error) {
            return false;
        }
    }),
});

export default function AdminGameTemplateForm(props) {
	const {
		initialData={},
		onClose,
		onSave,
	} = props;

	const { formData, isValid, handleUpdate, invalidFields } = useFormHandlers(
        initialData,
        schema,
    );

	const handleSubmit = () => {
		onSave(formData);
	};

    return (
        <form onSubmit={handleSubmit}>
	        <TextBox
		        // defaultOnEnter
		        name="gameSettings"
		        onChange={handleUpdate}
		        textArea
		        value={formData.gameSettings}
		        hasError={includes(invalidFields, "gameSettings")}
	        />
	        <div className="flex justify-flex-end spaced-content">
	            <Button
		            onClick={onClose}
		            type="gray"
	            >
		            Cancel
				</Button>
	            <Button
		            disabled={!isValid}
		            onClick={handleSubmit}
	            >
		            Submit
				</Button>
	        </div>
        </form>

    );
}

AdminGameTemplateForm.propTypes = {
    initialData: PropTypes.object,
	onClose: PropTypes.func.isRequired,
};
